export enum SystemRoles {
  DEVELOPER = 'developer',
  SUPER_ADMIN = 'super-admin',
  MULTIPLE_ACCOUNTS_ADMIN = 'multiple-accounts-admin',
  ADMIN = 'admin',
  LEARNER = 'learner',
  COMMERCIAL_ADMIN = 'commercial-admin',
}
